import Dropzone from "./dropzone";

export default Dropzone;
